import { Card, CardContent, Grid, Icon } from '@mui/material'
import React, { Component } from 'react'
import i18n from 'simple-react-i18n'

class DevelopmentApp extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Card>
                <CardContent>
                    <Grid container spacing={1} alignItems='center'>
                        <Grid size='auto'>
                            <Icon fontSize='large'>sort</Icon>
                        </Grid>
                        <Grid size='auto'>
                            <h6>{i18n.inDeveloppmentFunctionnality}</h6>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        )
    }
}

export default DevelopmentApp
